import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { WkoHighchart } from "../WkoHighchart";
const getChartOptions = (points) => ({
    chart: {
        type: "scatter",
        height: 300,
        backgroundColor: "transparent",
    },
    title: { text: undefined },
    exporting: { enabled: false },
    legend: { enabled: false },
    xAxis: {
        title: { text: "NC days per crew" },
        gridLineWidth: 1,
        type: undefined,
    },
    yAxis: {
        title: { text: "Hours per crew" },
        min: undefined,
    },
    plotOptions: {
        scatter: {
            marker: {
                radius: 5,
                fillColor: "rgba(69, 114, 160, 0.6)",
                lineWidth: 1,
                lineColor: "#4572a0",
            },
        },
    },
    tooltip: {
        formatter: function () {
            return `<b>${this.point.options.vesselName}</b><br/>NC days/crew: ${this.x}<br/>Hours/crew: ${this.y}`;
        },
    },
    series: [
        {
            type: "scatter",
            name: "Vessels",
            data: points,
        },
    ],
});
const mapPoints = (data) => {
    return data.map((point) => ({
        x: point.NcRatePerHead,
        y: point.HoursPerHead,
        vesselName: point.VesselName,
    }));
};
export const HoursPerHeadScatter = ({ options }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [scatterData, setScatterData] = useState([]);
    useEffect(() => {
        if (!options.isReady) {
            setIsLoading(false);
            setErrorMessage("");
            setScatterData([]);
            return;
        }
        setIsLoading(true);
        setErrorMessage("");
        setScatterData([]);
        const params = new URLSearchParams();
        params.append("year", String(options.year));
        params.append("quarter", String(options.quarter));
        options.fleetIds.forEach((id) => params.append("fleetIds", String(id)));
        fetch(`/api/insights/workload/hoursperhead?${params}`)
            .then((res) => {
            if (res.status === 204)
                return null;
            if (res.ok)
                return res.json();
            throw new Error(res.statusText);
        })
            .then((data) => {
            if (data !== null) {
                setScatterData(data);
            }
        })
            .catch((error) => {
            console.error(error);
            setErrorMessage("Error fetching hours per head data");
        })
            .finally(() => setIsLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [options.isReady, options.year, options.quarter, options.fleetIds]);
    const points = mapPoints(scatterData);
    return (_jsxs("div", { className: "card shadow h-100", children: [_jsx("h3", { className: "card-header", children: "Hours per crew vs NC days per crew" }), _jsxs("div", { className: "card-body d-flex flex-column", children: [(!options.isReady || isLoading) && (_jsxs("div", { className: "text-center py-4", children: [_jsx("span", { className: "spinner-grow spinner-grow-sm", role: "status", "aria-hidden": "true" }), " Loading..."] })), options.isReady && errorMessage && (_jsx("div", { className: "alert alert-danger", role: "alert", children: errorMessage })), options.isReady && !isLoading && scatterData.length > 0 && (_jsxs(_Fragment, { children: [_jsx("div", { style: { minHeight: "260px" }, children: _jsx(WkoHighchart, { options: getChartOptions(points) }) }), _jsxs("p", { className: "text-muted mb-0 mt-auto", children: [_jsx("span", { children: scatterData.length }), " vessels"] })] })), options.isReady && !isLoading && scatterData.length === 0 && (_jsx("p", { className: "text-muted mb-0", children: "No data available for this period." }))] })] }));
};
